import { Button } from '@mui/material'
import React, { useContext, useState } from 'react'
import ImageUploaderSystem from '../../../../../../../uploadImageSystem/ImageUploaderSystem'
import { MdCamera } from 'react-icons/md'
import withStyles from '@mui/styles/withStyles'
import { AuthContext } from '../../../../../../../../context/AuthContext'

const styles = () => ({
  button: {
    borderRadius: '10px !important',
    margin: '2px !important',
    textTransform: 'none !important',
    fontWeight: '550 !important',
    width: '100% !important',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important",
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
})

const NewGlobalInquiryImages = ({ classes, images, setImages }) => {
  const { user } = useContext(AuthContext)
  return (
    <>
      <section className={classes.buttonsWrapper}>
        <Button variant='outlined' className={classes.button}>
          <ImageUploaderSystem
            imageIcon={<MdCamera size={20} />}
            funtionalityIndex={0}
            images={images}
            setImages={setImages}
          />
        </Button>
      </section>
      <ImageUploaderSystem
        funtionalityIndex={1}
        images={images}
        setImages={setImages}
        pathName={`users/${user?._id}/globalInquiries`}
      />
    </>
  )
}

const WrappedNewGlobalInquiryImages = withStyles(styles)(NewGlobalInquiryImages)

export default WrappedNewGlobalInquiryImages
